function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "md-notifications-outline",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M177,72.471 C184.083,72.471 200.911,76.95 200.911,76.95 C246.5,87.397 278.589,129.389 278.589,176.8 L278.589,304.412 L287.91,313.776 L295.698,321.599 L56.302,321.599 L64.09,313.776 L73.411,304.412 L73.411,176.8 C73.411,129.39 105.5,87.397 151.089,76.95 C151.089,76.95 169.132,72.471 175,72.471 M176,0 C158.398,0 144.941,13.518 144.941,31.2 L144.941,45.759 C85.926,59.282 41.411,113.36 41.411,176.8 L41.411,291.2 L0,332.8 L0,353.6 L352,353.6 L352,332.8 L310.589,291.2 L310.589,176.8 C310.589,113.36 266.073,59.282 207.059,45.759 L207.059,31.2 C207.059,13.518 193.602,0 176,0 Z M217.411,374.4 L134.588,374.4 C134.588,397.281 153.221,416 176,416 C198.779,416 217.411,397.281 217.411,374.4 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 5,
  fill: "#EB7924",
  cx: 241,
  cy: 47,
  r: 47
})));

var SvgNotificationsBellActive = function SvgNotificationsBellActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 352 419",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationsBellActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifications-bell-active.a9adeacc.svg";
export { ForwardRef as ReactComponent };